<nb-accordion multi kwExpandFirstItem>
    <nb-accordion-item *ngFor="let field of fields;let i = index" [expanded]="i == '0'">
        <nb-accordion-item-header>{{field?.title}}</nb-accordion-item-header>
        <nb-accordion-item-body>
            <kve-field-editor [field]="field"></kve-field-editor>
        </nb-accordion-item-body>
    </nb-accordion-item>
</nb-accordion>

<!-- <div class="content-cell bordered">
    <kve-editor-input-header [title]="title" [toolTip]="toolTip"></kve-editor-input-header>
    <div class="content-cell">
        <div class="cell-content">
            <kve-editor-inline-form>
                <form class="form-inline">
                    <label class="inline-label" for="inlineFormCustomSelectPref">Width</label>
                    <div class="inline-select">
                        <nb-select fullWidth placeholder="Select Width" [(selected)]="selectedItem" class="my-1 mr-sm-2" size="small">
                            <nb-option value="768">768</nb-option>
                            <nb-option value="1024">1024</nb-option>
                            <nb-option value="1280">1280 (recommended)</nb-option>
                            <nb-option value="1366">1366</nb-option>
                            <nb-option value="1440">1440</nb-option>
                            <nb-option value="1536">1536</nb-option>
                            <nb-option value="1600">1600</nb-option>
                            <nb-option value="1920">1920</nb-option>
                        </nb-select>
                    </div>
                    <div class="inline-submit">
                        <button nbButton size="tiny" type="submit" status="primary">Submit</button>
                    </div>
                </form>
            </kve-editor-inline-form>
        </div>
    </div>
    <kve-editor-footer></kve-editor-footer>
</div> -->